import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as empresasApi from '../../api/empresas';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { formatCnpj } from '../../utils/cpf';
import { getErrorMessage } from '../../utils/apiError';

export default function EmpresaForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const editando = Boolean(id);

  const [form, setForm] = useState({ nome: '', cnpj: '', telefone: '', ativo: true });
  const [loading, setLoading] = useState(editando);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (!editando) return;
    empresasApi
      .getEmpresa(id)
      .then((r) => setForm(r.data))
      .catch(() => setErro('Erro ao carregar empresa.'))
      .finally(() => setLoading(false));
  }, [id, editando]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setSalvando(true);
    try {
      if (editando) await empresasApi.updateEmpresa(id, form);
      else await empresasApi.createEmpresa(form);
      navigate('/empresas');
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao salvar empresa.'));
    } finally {
      setSalvando(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <PageHeader titulo={editando ? 'Editar empresa' : 'Nova empresa'} />
      <form onSubmit={handleSubmit} className="sf-card p-4" style={{ maxWidth: 560 }}>
        {erro && (
          <div className="sf-login-alert mb-3">
            <i className="bi bi-exclamation-circle" />
            {erro}
          </div>
        )}

        <label className="sf-field-label mb-3">
          <span>Nome</span>
          <span className="sf-field">
            <i className="bi bi-building" />
            <input required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} />
          </span>
        </label>

        <label className="sf-field-label mb-3">
          <span>CNPJ</span>
          <span className="sf-field">
            <i className="bi bi-file-earmark-text" />
            <input value={form.cnpj || ''} onChange={(e) => setForm({ ...form, cnpj: formatCnpj(e.target.value.replace(/\D/g, '')) })} />
          </span>
        </label>

        <label className="sf-field-label mb-3">
          <span>Telefone</span>
          <span className="sf-field">
            <i className="bi bi-telephone" />
            <input value={form.telefone || ''} onChange={(e) => setForm({ ...form, telefone: e.target.value })} />
          </span>
        </label>

        {editando && (
          <label className="sf-login-check mb-3">
            <input
              type="checkbox"
              checked={form.ativo}
              onChange={(e) => setForm({ ...form, ativo: e.target.checked })}
            />
            Ativa
          </label>
        )}

        <button type="submit" className="sf-btn sf-btn-primary" disabled={salvando}>
          {salvando ? 'Salvando...' : 'Salvar'}
        </button>
      </form>
    </div>
  );
}
